export const USE_TOKEN = "useToken";
export const REFRESH_TOKEN = "refreshToken";
export const ACCESS_TOKEN = "accessToken";
export const LOGOUT = "logout";

export default {
    namespaced: true,
    state: {
        refreshToken: null,
        accessToken: null,
    },

    getters: {
        [REFRESH_TOKEN](state) {
            return state.refreshToken;
        },
        [ACCESS_TOKEN](state) {
            return state.accessToken;
        },
        authorities(_, getter) {
            const at = getter[ACCESS_TOKEN];
            return at ? at.authorities : [];
        },
        logged: state => state.accessToken != null,
    },
    actions: {
        [LOGOUT]({ commit }) {
            commit(USE_TOKEN, {});
        },
    },

    mutations: {
        [USE_TOKEN](state, { accessToken, refreshToken }) {
            state.accessToken = accessToken;
            state.refreshToken = refreshToken;
        },
    },
}
